import React from 'react'
import { Fade } from '@mui/material'
import { SnackbarProvider } from 'notistack'

const NotificationsProvider = (props) => (
    <SnackbarProvider
        maxSnack={5}
        preventDuplicate
        autoHideDuration={5000}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        TransitionComponent={Fade}
        {...props}
    />
)

export default NotificationsProvider
